import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import "./CreateTest.css";

const apiUrl = "https://maintenance.cscoreentities.devtest.gf.aws.scania.com/loadrunner";

const CreateTest = () => {
  const location = useLocation();
  const [fields, setFields] = useState({
    httpMethod: "GET",
    authToken: "",
    methodBody: "",
    uri: "",
    duration: "",
    concurrency: "",
    rampup: "",
    uuid: uuidv4(),
    description: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [fetchRestAPIStatus, setFetchRestAPIStatus] = useState("");

  useEffect(() => {
    const testUUId = new URLSearchParams(location.search).get("testUUId");
    if (testUUId) {
      getAllTestResultsFromDb(testUUId);
    }
  }, [location.search]);

  const handleOnChange = (event) => {
    const { id, value } = event.target;
    setFields((prevFields) => ({
      ...prevFields,
      [id]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: "",
    }));
  };

  const validateFields = () => {
    const newErrors = {};
    const requiredFields = [
      "httpMethod",
      "uri",
      "duration",
      "concurrency",
      "rampup",
    ];
    requiredFields.forEach((field) => {
      if (!fields[field]) {
        newErrors[field] = `${field} is required!!`;
      }
    });
    return newErrors;
  };

  const handleCreateTest = async () => {
    const newErrors = validateFields();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      scrollToError();
    } else {
      setIsLoading(true);
      const jwt = localStorage.getItem("token");
      const post_data = createDtoForRunner();
      try {
        await axios.post(`${apiUrl}/jwt/api/v1/StartRunner`, post_data, {
          headers: {
            "Content-Type": "application/json",
            "X-Client": "ce/pulse-web-console",
            "Access-Control-Allow-Origin": "*",
            Authorization: jwt,
          },
        });
        setFetchRestAPIStatus(`TestId: ${post_data.UUID} initiated.`);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        setFetchError(err.message);
      }
    }
  };

  const createDtoForRunner = () => {
    return {
      S3_BUCKET: "ankur-test-taurus-docker",
      TEST_ID: "taurus_execution",
      PREFIX: "ce",
      TEST_VAR: "Test initiated from React PULSE tool",
      UUID: fields.uuid,
      Uri: fields.uri,
      AuthToken: fields.authToken,
      HttpMethod: fields.httpMethod,
      MethodBody: fields.methodBody,
      taurusJobExecutionDto: {
        Concurrency: fields.concurrency,
        HoldFor: `${fields.duration}m`,
        RampUp: `${fields.rampup}s`,
      },
    };
  };

  const scrollToError = () => {
    const errorElements = document.getElementsByClassName("error-text");
    if (errorElements.length > 0) {
      errorElements[0].scrollIntoView();
    }
  };

  const getAllTestResultsFromDb = async (testUUId) => {
    const jwt = localStorage.getItem("token");
    try {
      const { data } = await axios.post(
        `${apiUrl}/jwt/api/v1/GetAllTestResultsFromDb`,
        { UUID: testUUId },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Client": "ce/pulse-web-console",
            "Access-Control-Allow-Origin": "*",
            Authorization: jwt,
          },
        }
      );

      setFields({
        httpMethod: data.httpMethod,
        methodBody: data.methodBody,
        uri: data.uri,
        duration: data.holdFor.slice(0, -1),
        concurrency: data.concurrency,
        rampup: data.rampUp.slice(0, -1),
        uuid: uuidv4(),
        description: "",
      });
      setFetchRestAPIStatus(`Test cloned using ID ${data.uuid}`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="createtestscenario-page">
      <div className="form">
        <form className="login-form">
          {isLoading && (
            <div className="loading">
              <ScaleLoader height="30px" width="10px" color="#4287f5" />
            </div>
          )}
          {/* Form fields */}
          {[
            { label: "HttpMethod", type: "text", id: "httpMethod" },
            { label: "URI", type: "text", id: "uri" },
            { label: "Authorization", type: "text", id: "authToken" },
            { label: "MethodBody", type: "text", id: "methodBody" },
            {
              label: "Duration (minutes)",
              type: "number",
              id: "duration",
              min: "1",
              max: "50",
            },
            {
              label: "Concurrency",
              type: "number",
              id: "concurrency",
              min: "1",
              max: "100",
            },
            {
              label: "Ramp-Up (seconds)",
              type: "number",
              id: "rampup",
              min: "1",
              max: "30",
            },
            {
              label: "TestId (AutoGenerated)",
              type: "text",
              id: "uuid",
              readOnly: true,
            },
            { label: "Description", type: "text", id: "description" },
          ].map(({ label, type, id, ...rest }) => (
            <div className="form-group" key={id}>
              <label htmlFor={id}>{label}:</label>
              <br></br>
              <input
                type={type}
                className="form-control"
                value={fields[id]}
                onChange={handleOnChange}
                id={id}
                {...rest}
              />
              {errors[id] && <small className="error-text">{errors[id]}</small>}
            </div>
          ))}
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleCreateTest}
          >
            Start
          </button>
          {fetchError && (
            <p style={{ color: "red" }}>API_Status: {fetchError}</p>
          )}
          {fetchRestAPIStatus && (
            <p style={{ color: "green" }}>{fetchRestAPIStatus}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default CreateTest;
